import {
    Card, CardContent, TextField, Button, makeStyles, Snackbar, Dialog, DialogContent, DialogActions,
    TableContainer, Table, TableHead, TableRow, CircularProgress, Paper, TableBody, TableCell, CardActions
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
import { getRoles } from '../auth-provider/ra-auth-jwt';
import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import { apolloClient as client } from "../data-provider/graphqlDataProvider";
// const client = new ApolloClient({
//     uri: `${process.env.REACT_APP_DATAPROVIDER}`,
//     headers: { authorization: token },
//     cache: new InMemoryCache(),
//     defaultOptions: {
//         watchQuery: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'ignore',
//         },
//         query: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'all',
//         },
//     }
// });

const useStyles = makeStyles((theme) => ({
    cancelBtn: {
        backgroundColor: 'rgb(220, 0, 78)',
        width: '20%',
        '&:hover': {
            backgroundColor: 'rgb(220, 0, 78)'
        }
    },
    table: {
        minWidth: 650,
    }
}));

async function getStepByTransactionId(transactionId: string) {
    const GET_STEPS = gql`
    {
        payments(where:{humanizedId:{equals: ${transactionId}}}){
          paymentSteps{
            id
            input
            createdAt
            step
            payment {
              humanizedId
              status
              token
              amount
            }
          }
        
        }
      }
  `;

    return client.query({
        query: GET_STEPS
    })
}

// async function updatePayment(data: any) {
//     let token: any = localStorage.getItem('credentials')
//     return axiosWithAuthInterceptor({
//         url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/payments/snapp-pay/update`,
//         data: data,
//         method: 'POST',
//     })
// }

const status: Record<string, string> = {
    PENDING: 'در انتظار پرداخت',
    FAILED: 'خطا',
    SUCCESS: 'موفق',
    CANCELED: 'لغو شده'
}

export function UpdateTaraPayment() {
    const classes = useStyles();
    const [mobile, setMobile] = useState("");
    const [transactionId, setTransactionId] = useState("");
    const [rowsLoading, setRowsLoading] = useState(false);
    const [serverState, setServerState] = useState({
        fetchData: { status: 'NONE', message: '' },
        submit: { status: 'NONE', message: '' }
    }
    )
    const [modal, setModal] = useState({
        isOpen: false,
        method: ''
    })
    const [paymentList, setPaymentList] = useState<Array<any>>([]);
    const [selectedPayment, setSelectedPayment] = useState<any>();
    const [inputAmount, setInputAmount] = useState<any>(null);
    const search = async () => {
        setServerState({ ...serverState, fetchData: { ...serverState.fetchData, status: 'PENDING' } })
        setRowsLoading(true)
        setSelectedPayment("")

        if (transactionId) {
            getStepByTransactionId(transactionId).then((res: any) => {
                console.log('res: ', res.data.payments[0].paymentSteps);
                setPaymentList(res.data.payments[0].paymentSteps.filter((ps: any) => ps.step === "GET_TOKEN"));
                setServerState({ ...serverState, fetchData: { ...serverState.fetchData, status: 'SUCCESSFUL' } })
                setRowsLoading(false)
            })
        }

    }

    const submit = async () => {
        // console.log('selectedPayment: ', selectedPayment);
        // console.log('inputAmount: ', inputAmount);
        
        setServerState({ ...serverState, submit: { message: 'با موفقیت انجام شد', status: 'PENDING' } })
        if (modal.method === 'CANCEL') {
            let token: any = localStorage.getItem('credentials')
            await axiosWithAuthInterceptor(
                {
                    method: 'post',
                    url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/payments/tara/cancel`,
                    data: {
                        transactionId: selectedPayment.payment.humanizedId,
                        amount: parseInt(inputAmount)
                    },
                }

            ).then((res: any) => {
                if (res.data.err) {
                    let message = "";
                    switch (res.data.err.message) {
                        case "payment-not-found":
                            message = "سفارشی با این شماره پرداخت وجود ندارد"
                            break;
                        case "Bad Request":
                            message = "درخواست شما درست نیست"
                            break;
                        case "duplicates-error":
                            message = "بخشی از پرداختی این شماره قبلا عودت داده شده است!"
                            break;
                        default:
                            message = "با خطا مواجه شد"
                            break;
                    }
                    setServerState({ ...serverState, submit: { message: message, status: 'ERROR' } })
                    document.querySelector('.MuiSnackbarContent-root')?.classList.add('snack-error')
                  
                }
                else {
                    setServerState({ ...serverState, submit: { message: 'با موفقیت انجام شد', status: 'SUCCESSFUL' } })
                    document.querySelector('.MuiSnackbarContent-root')?.classList.add('snack-successful')
                    setInputAmount(null)
                    //setSelectedPayment("")
                    //search()
                }
            }).catch((error => {
                setServerState({ ...serverState, submit: { message: 'با خطا مواجه شد', status: 'ERROR' } })
                document.querySelector('.MuiSnackbarContent-root')?.classList.add('snack-error')
                setInputAmount(null)
            }))
        }


    }

    // const prepareDataForServer = () => {
    //     let data = {
    //         amount: 0,
    //         cartList: selectedPayment.input.cartList,
    //         transactionId: selectedPayment.input.transactionId,
    //         discountAmount: 0,
    //         paymentMethodTypeDto: selectedPayment.input.paymentMethodTypeDto,
    //         paymentToken: selectedPayment.payment.token
    //     }
    //     let amountNumber = Number(selectedPayment.input.amount)
    //     data.amount = amountNumber
    //     data.cartList[0].cartItems[0].amount = amountNumber
    //     data.cartList[0].totalAmount = amountNumber

    //     return data;
    // }

    // const updatePaymentListState = () => {
    //     let result = paymentList.map((p: any) => {
    //         if (p.id === selectedPayment.id)
    //             return {
    //                 ...p,
    //                 input: { ...p.input, amount: Number(selectedPayment.input.amount) }
    //             }
    //         return p
    //     })
    //     setPaymentList(result)
    // }

    const getPaymentDetails = async (paymentId: string) => {
        setServerState({ ...serverState, submit: { message: '', status: 'NONE' } })
        setSelectedPayment(paymentList.find((sp: any) => sp.id === paymentId))
        return null;
    }

    // const changeProductSold = (value: string) => {
    //     let cartItem = {
    //         ...selectedPayment.input.cartList[0].cartItems[0],
    //         name: value,
    //         category: value
    //     }
    //     setSelectedPayment({
    //         ...selectedPayment,
    //         input: {
    //             ...selectedPayment.input,
    //             cartList: [{ ...selectedPayment.input.cartList[0], cartItems: [{ ...cartItem }] }]
    //         }
    //     })
    // }

    const changeAmount = (value: string) => {
        setInputAmount(value)
        let newAmount = Number(value)
        let cartItem = [{
            ...selectedPayment.input.cartList[0].cartItems[0],
            amount: newAmount,
        }]
        let cartList = [{
            ...selectedPayment.input.cartList[0],
            totalAmount: newAmount,
            cartItems: cartItem
        }]
        setSelectedPayment({ ...selectedPayment, input: { ...selectedPayment.input, cartList: cartList, amount: newAmount } })
    }


    useEffect(() => {
        let roles = getRoles();
        let isPaymentManager = roles.some((r: any) => r === `${process.env.REACT_APP_AUTH_SERVICE}.payment_manager`)
        if (!isPaymentManager)
            window.location.href = '/'
    })

    return (
        <Card>
            <CardContent>
                <Dialog
                    onClick={(e) => { e.preventDefault(); e.stopPropagation() }}
                    disableEscapeKeyDown
                    maxWidth="xs"
                    aria-labelledby="confirmation-dialog-title"
                    open={modal.isOpen}
                >
                    <DialogContent>
                        {
                            modal.method === 'UPDATE' ?
                                <p style={{ fontFamily: 'IranSans-Bold' }}>
                                    آیا از به‌روزرسانی پرداخت با شماره تراکنش {selectedPayment?.payment?.humanizedId} به مبلغ {selectedPayment?.input?.amount.toLocaleString()} با نام {selectedPayment?.input?.cartList[0]?.cartItems[0].name} مطمئن هستید؟
                                </p> :
                                <p style={{ fontFamily: 'IranSans-Bold' }}>
                                    آیا از عودت پرداخت با شماره تراکنش {selectedPayment?.payment?.humanizedId} مطمئن هستید؟
                                </p>
                        }

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={(e) => setModal({ ...modal, isOpen: false })} color="primary">
                            لغو
                        </Button>
                        {
                            serverState.submit.status !== "PENDING" ?
                                <Button onClick={(e) => submit()} color="primary">
                                    تایید
                                </Button> :

                                <CircularProgress style={{ padding: '0px 8px' }} size={"1rem"} />

                        }
                    </DialogActions>
                    <Snackbar
                        open={serverState.submit.status === 'ERROR' || serverState.submit.status === 'SUCCESSFUL' ? true : false}
                        onClose={() => {
                            setServerState({ ...serverState, submit: { ...serverState.submit, status: 'NONE' } });
                            setModal({ ...modal, isOpen: false });
                        }}
                        autoHideDuration={1500}
                        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                        message={serverState.submit.message}
                        style={{ backgroundColor: 'transparent', borderRadius: '12px' }}
                    />
                </Dialog>


                {/* Search Panel */}
                <div className='search-panel' style={{ marginBottom: '2rem' }}>
                    <p style={{ fontFamily: 'IranSans-Bold' }}>
                        برای پیدا کردن تراکنش موردنظر، یکی از فیلدهای زیر را پُر و جستجو کنید.
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'cnter', gap: '1rem' }}>
                        <TextField
                            id="outlined-select-currency-native"
                            onChange={(e) => { setTransactionId(e.target.value); setMobile("") }}
                            variant="outlined"
                            value={transactionId}
                            placeholder="شماره تراکنش"
                        >
                        </TextField>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button disabled={(mobile.length === 11 || transactionId.length >= 2) ? false : true} onClick={() => search()} variant="contained" color="secondary">
                            جستجو
                        </Button>
                    </div>
                </div>

                {/* Table */}
                {
                    serverState.fetchData.status !== "NONE" ? <>
                        {
                            !rowsLoading ?
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} aria-label="a dense table">
                                        {paymentList.length > 0 ?
                                            <>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ fontWeight: 700 }} align="center">شماره موبایل</TableCell>
                                                        <TableCell style={{ fontWeight: 700 }} align="center">شماره تراکنش</TableCell>
                                                        <TableCell style={{ fontWeight: 700 }} align="center">تاریخ پرداخت</TableCell>
                                                        <TableCell style={{ fontWeight: 700 }} align="center">مبلغ پرداخت</TableCell>
                                                        <TableCell style={{ fontWeight: 700 }} align="center">وضعیت پرداخت</TableCell>
                                                        <TableCell style={{ fontWeight: 700 }} align="center"></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {paymentList.map((row) => (
                                                        <TableRow key={row.id}>
                                                            <TableCell align="center" style={{ direction: 'ltr' }}>{ row.input.cellNumber}</TableCell>
                                                            <TableCell align="center">{row.payment.humanizedId}</TableCell>
                                                            <TableCell align="center">{new Date(row.createdAt).toLocaleDateString('fa-IR')}</TableCell>
                                                            <TableCell align="center">{row.payment.amount?.toLocaleString('fa')}</TableCell>
                                                            <TableCell align="center">{status[row.payment.status.toUpperCase()]}</TableCell>
                                                            {
                                                                <TableCell align="center"><Button onClick={(e: any) => getPaymentDetails(row.id)} color="primary">ویرایش</Button></TableCell> 
                                                            }
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </> :
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell align="center">رکوردی وجود ندارد</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        }
                                    </Table>
                                </TableContainer> :
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '5rem' }}>
                                    <CircularProgress />
                                </div>

                        }
                    </> : ''
                }


                {selectedPayment ?
                    <Card style={{ marginTop: '2rem' }}>
                        <CardContent>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '3rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                    <p style={{ fontFamily: 'IranSans-Bold' }}>مبلغ بازگشتی به مشتری (تومان):</p>
                                    <TextField
                                        id="outlined-select-currency-native"
                                        variant="outlined"
                                        type="number"
                                        placeholder="مبلغ بازگشتی به مشتری "
                                        onChange={(e: any) => changeAmount(e.target.value)}
                                    >
                                    </TextField>
                                </div>
                            </div>
                        </CardContent>
                        <CardActions style={{ direction: 'ltr' }}>
                            <Button onClick={() => setModal({ method: 'CANCEL', isOpen: true })} className={classes.cancelBtn} variant="contained" color="secondary">
                                بازگشت وجه
                            </Button>
                        </CardActions>
                    </Card>
                    : ''}



            </CardContent>
        </Card >
    )
}